module.exports = __webpack_public_path__ + "static/media/picAttch.2923e456.png";